module.exports = __webpack_public_path__ + "static/media/4.aa427893.jpg";